import React from 'react';
import { cn } from '@/helpers/utils';
import { useRouteParams } from '@/context/routeParamsContext';
import { useLoungeAmenitiesWithLocaleTranslations } from '@/hooks/loungesHooks/loungesHelperHooks';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { amenityIdToIconMap } from '@/constants/amenityIconMapping';

import { IconLounge } from '../icons';

const LoungeDetailsAmenitiesList = () => {
  const { loungeId } = useRouteParams();
  const amenities = useLoungeAmenitiesWithLocaleTranslations(loungeId);
  const content = useCommonContent();

  return (
    <div className="margin-0-b">
      <h2 className="margin-1-b tw-heading-xs-bold tw-text-gray-900">
        {content?.amenities?.header}
      </h2>
      <ul
        id="lounge-overview-amenity-list"
        className={cn(
          'pad-0-lr tw-mt-4 tw-grid tw-grid-cols-1 sm_tw-grid-cols-2'
        )}
      >
        {amenities.map((amenity) => {
          const TheIcon = amenityIdToIconMap[amenity.id] || IconLounge;

          return (
            <li
              key={amenity.id}
              data-testid="amenity-item"
              className={cn(
                'leading-4 ps-0 pe-0 flex tw-mb-4 tw-mr-6 svg-children_tw-fill-gray-800',
                amenity.id
              )}
            >
              <div>
                <TheIcon
                  role="img"
                  aria-hidden="true"
                  className="tw-mr-2"
                  color="inherit"
                  size="md"
                />
              </div>
              {amenity.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LoungeDetailsAmenitiesList;
